<template>
    <section class='main'>
        <div class='crumbs'>
            <el-breadcrumb separator='/'>
                <el-breadcrumb-item><i class='el-icon-lx-profile'></i> 实名相关</el-breadcrumb-item>
                <el-breadcrumb-item>防沉迷设置</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        
        <div class='container' style='min-width: 900px'>
            <div class='plugins-tips'>
                <el-row>
                    <el-col :span='22'>
                        <el-form v-show='showSearch' ref='queryForm' :inline='true' :model='queryParams' size='small'>
                            <el-form-item style='margin-bottom: 0'>
                                <el-select clearable size='mini' v-model='queryParams.projectId' placeholder='项目名'>
                                    <el-option
                                        v-for='item in projectInfoList'
                                        :key='item.id'
                                        :label='item.cnName'
                                        :value='item.id'>
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item style='margin-bottom: 0'>
                                <el-select size='mini' v-model='queryParams.type' placeholder='防沉迷设置类型'>
                                    <el-option
                                        v-for='item in antiAddictionTypeList'
                                        :key='item.value'
                                        :label='item.label'
                                        :value='item.value'>
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item style='margin-bottom: 0'>
                                <el-button icon='el-icon-search' size='mini' type='primary' @click='handleQuery'>搜索
                                </el-button>
                                <el-button icon='el-icon-refresh' size='mini' @click='resetQuery'>重置</el-button>
                            </el-form-item>
                        </el-form>
                    </el-col>
                    <el-col :span='2'>
                        <el-row class='mb8'>
                            <el-col :span='8'>
                                <el-button
                                    icon='el-icon-plus'
                                    plain
                                    size='mini'
                                    type='primary'
                                    @click='handleAdd'
                                >新增
                                </el-button>
                            </el-col>
                        </el-row>
                    </el-col>
                </el-row>
            </div>
            
            
            <el-table v-loading='loading' :cell-style="{ textAlign: 'center' }" :data='antiAddictionSettingList'
                      @selection-change='handleSelectionChange'>
                <!--<el-table-column align='center' type='selection' width='55' />-->
                <el-table-column :show-overflow-tooltip='true' align='center' label='防沉迷设置名称' prop='name' />
                <el-table-column :show-overflow-tooltip='true' align='center' label='设置数据' prop='settingData'/>
                <el-table-column :show-overflow-tooltip='true' align='center' label='防沉迷设置类型' prop='type'/>
                <el-table-column :show-overflow-tooltip='true' align='center' label='绑定项目'>
                    <template slot-scope='scope'>
                        <span>{{ projectInfoMap.get(scope.row.projectId) }}</span>
                    </template>
                </el-table-column>
                <el-table-column :show-overflow-tooltip='true' align='center' label='创建时间' prop='createTime' />
                <el-table-column :show-overflow-tooltip='true' align='center' label='最后更新时间' prop='updateTime' />
                <el-table-column fixed='right' align='center' width='200' class-name='small-padding fixed-width'
                                 label='操作'>
                    <template slot-scope='scope'>
                        <el-button
                            icon='el-icon-edit'
                            size='mini'
                            type='text'
                            @click='handleUpdate(scope.row)'
                        >修改
                        </el-button>
                        <el-button
                            icon='el-icon-delete'
                            size='mini'
                            type='text'
                            @click='handleDelete(scope.row)'
                        >删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            
            <div class='pagination'>
                <el-pagination
                    :current-page='queryParams.pageNum'
                    :page-size='queryParams.pageSize'
                    :total='queryParams.total'
                    background
                    layout='prev, pager, next'
                    @current-change='handlePagination'>
                </el-pagination>
            </div>
            
            <!-- 添加或修改参数配置对话框 -->
            <el-dialog :title='title' :before-close='cancel' :visible.sync='open' append-to-body width='40%'>
                <el-form label-position='left' ref='form' label-width='150px'>
                    <el-form-item label='防沉迷设置名称' prop='url'>
                        <el-input type='text' size='mini' v-model='currentAntiAddictionSetting.name'/>
                    </el-form-item>
                    <el-form-item label='将设置绑定到项目' prop='url'>
                        <el-select :disabled='currentAntiAddictionSetting.type === "COMMON"' size='mini' v-model='currentAntiAddictionSetting.projectId' placeholder='请选择'>
                            <el-option
                                v-for='item in projectInfoList'
                                :key='item.id'
                                :label='item.cnName'
                                :value='item.id'>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label='防沉迷设置类型' prop='url'>
                        <el-select size='mini' v-model='currentAntiAddictionSetting.type' placeholder='请选择'>
                            <el-option
                                v-for='item in antiAddictionTypeList'
                                :key='item.value'
                                :label='item.label'
                                :value='item.value'>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <cotton-dynamic-form warning-type='warning'
                                         key-name='防沉迷配置项名'
                                         value-name='防沉迷配置项值'
                                         warning-text='假设你的配置为{"company": "cotton", "setting": {"age": 12}}  则需要输入的字段和值分别为
                                         key: company, value: cotton
                                         key: setting, value: {"age": 12}'
                                         @getDynamicJsonString='getDynamicJsonString' json-key='settingData'
                                         :json-object='currentAntiAddictionSetting'/>
                </el-form>
                <div slot='footer' class='dialog-footer'>
                    <el-button type='primary' @click='submitForm'>确 定</el-button>
                    <el-button @click='cancel'>取 消</el-button>
                </div>
            </el-dialog>
        </div>
    </section>
</template>

<script>

import { message } from '@/utils/message';
import { deepCopy } from '@/utils/object';
import { queryProjectInfoList } from '@/components/api/ProjectInfo';
import {
    deleteAntiAddictionSetting,
    insertAntiAddictionSetting,
    queryAntiAddictionSetting,
    updateAntiAddictionSetting
} from '@/components/api/AntiAddictionSetting';

export default {
    name: 'Dict',
    data() {
        return {
            projectSettingList: [],
            // 遮罩层
            loading: true,
            // 选中数组
            ids: [],
            batchDeleteStatus: false,
            // 显示搜索条件
            showSearch: true,
            // 弹出层标题
            title: '',
            // 是否显示弹出层
            open: false,
            // 查询参数
            queryParams: {
                total: 0,
                pageNum: 1,
                pageSize: 15,
                projectId: undefined,
                type: undefined
            },
            updateStatus: false,
            currentAntiAddictionSetting: {
                settingData: ''
            },
            projectInfoMap: new Map,
            antiAddictionSettingList: [],
            projectInfoList: [],
            antiAddictionTypeList: [
                {
                    label: '公用',
                    value: 'COMMON'
                },
                {
                    label: '项目独有',
                    value: 'PROJECT'
                }
            ]
        };
    },
    created() {
        this.getList();
    },
    methods: {
        handlePagination(pageNum) {
            this.queryParams.pageNum = pageNum;
            this.getList();
        },
        /** 查询字典类型列表 */
        getList() {
            this.reset()
            this.loading = true;
            queryAntiAddictionSetting(this.queryParams).then(response => {
                if (response.code === 200) {
                    this.antiAddictionSettingList = response.data.result;
                    this.queryParams.total = response.data.total;
                    this.loading = false;
                    this.queryParams.pageNum = response.data.pageNum;
                } else {
                    this.loading = false;
                }
            });
            
            // 查询项目信息
            queryProjectInfoList({pageSize: 100000}).then(result => {
                if (result.code === 200) {
                    if (result.data && result.data.result) {
                        result.data.result.forEach(v => {
                            this.projectInfoList.push(v)
                            this.projectInfoMap.set(v.id, v.cnName)
                        })
                    }
                }
            })
        },
        getDynamicJsonString(jsonValue) {
            this.currentAntiAddictionSetting.settingData = jsonValue
        },
        // 取消按钮
        cancel() {
            this.open = false;
            this.getList()
        },
        // 表单重置
        reset() {
            this.projectSettingList = []
            this.projectInfoList = []
            this.projectInfoMap = new Map
            this.antiAddictionList = []
            this.currentAntiAddictionSetting = {
                settingData: ''
            }
        },
        /** 搜索按钮操作 */
        handleQuery() {
            this.queryParams.pageNum = 1;
            this.getList();
        },
        /** 重置按钮操作 */
        resetQuery() {
            this.queryParams = {};
            this.handleQuery();
        },
        /** 新增按钮操作 */
        handleAdd() {
            
            this.open = true;
            this.title = '增加防沉迷设置';
            this.updateStatus = false;
            this.currentProjectSetting = {
                settingData: ''
            }
        },
        handleBatchDelete() {
            let idList = this.ids;
            const obj = this;
            
        },
        // 多选框选中数据
        handleSelectionChange(selection) {
            this.ids = selection.map(item => item.id);
            this.batchDeleteStatus = this.ids.length > 0;
        },
        /** 修改按钮操作 */
        handleUpdate(row) {
            this.open = true;
            this.title = '修改防沉迷设置';
            this.updateStatus = true;
            this.currentAntiAddictionSetting = deepCopy(row)
        },
        /** 提交按钮 */
        async submitForm() {
            if (this.updateStatus) {
                updateAntiAddictionSetting(this.currentAntiAddictionSetting).then(result => {
                    if (result.code === 200) {
                        message.success('修改成功');
                        this.getList();
                        this.open = false;
                    }
                });
            } else {
                insertAntiAddictionSetting(this.currentAntiAddictionSetting).then(result => {
                    if (result.code === 200) {
                        message.success('添加成功');
                        this.getList();
                        this.open = false;
                    }
                });
            }
        },
        /** 删除按钮操作 */
        handleDelete(row) {
            this.$modal.confirm('是否确认删除"' + row.id + '"的数据项？').then(function() {
                return deleteAntiAddictionSetting(row);
            }).then((result) => {
                if (result.code === 200) {
                    this.getList();
                    this.$modal.msgSuccess('删除成功');
                }
            }).catch(() => {
            });
        },
    },
};
</script>
<style>

</style>